<template>
  <SvgSprite />
  <div class="as-matches" ref="scrollComponent">
    <div v-for="competition in leagues" :key="competition.id"
      :class="`as-competition-wrapper as-competition-wrapper-${siteName}`">
      <div class="as-league_title">
        <div class="as-match_competition">
          <img class="as-lazyload" :src="getImgUrlBySport('competition', competition.id)"
            :alt="getCompetitionNameShow(competition)" />{{ competition?.short_name || competition?.name }}
        </div>
        <div class="as-match__teams as-d-none as-d-lg-flex">
          <div class="as-match__team as-match__team--home">Chủ nhà</div>
          <div class="as-scoreboard">Tỷ số</div>
          <div class="as-match__team as-match__team--away">Khách</div>
        </div>
        <div class="as-match__video-highlight as-d-none as-d-lg-flex"></div>
        <div class="as-match__ht as-d-none as-d-lg-flex">HT</div>
        <div class="as-match__corner as-d-none as-d-lg-flex">
          <IconCornerNew :width="12" /> HT | FT
        </div>
        <div class="as-match__yellow-goal as-d-none as-d-lg-flex">
          <IconYellowCard :width="12" :height="16" /> HT | FT
        </div>
      </div>

      <div v-for="match in competition.matchs" :key="match.id" :data-id="match.id" class="as-match__item">
        <div class="as-match__item--wrap">
          <div class="as-match__sm">
            <div class="as-match__label">
              <div class="as-match__label-item">
                {{ formatLocalTime(match.match_time, "h:mm DD/MM") }}
              </div>
              <div class="as-match__label-item" v-if="match.round?.round_num && match.round?.round_num != 0">
                {{ `Vòng ${match.round?.round_num}` }}
              </div>
            </div>
            <div class="as-match__video-highlight as-d-flex as-d-lg-none">
              <a v-if="match.highlight" :href="match.highlight?.url" rel="nofollow" title="Xem video highlight">
                <IconPlay fill="#c72a1d"/>
              </a>
            </div>
            <div class="as-match__label as-d-flex as-d-lg-none">
              <div class="as-match__label-item">
                <span class="as-active">HT</span>
                <div>
                  <span :class="{
                      'as-label-item-win':
                        match.home_scores[1] > match.away_scores[1],
                    }">{{ match.home_scores[1] }}
                  </span>
                  <span> - </span>
                  <span :class="{
                      'as-label-item-win':
                        match.home_scores[1] < match.away_scores[1],
                    }">{{ match.away_scores[1] }}
                  </span>
                </div>
              </div>
              <div class="as-match__label-item">
                <IconCornerNew />

                <div>
                  <span :class="{
                      'as-label-item-win':
                        match.home_scores[4] > match.away_scores[4],
                    }">{{ match.home_scores[4] }}
                  </span>
                  <span> - </span>
                  <span :class="{
                      'as-label-item-win':
                        match.home_scores[4] < match.away_scores[4],
                    }">{{ match.away_scores[4] }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="as-match__scores as-match__teams">
            <a :href="getLinkTeamDetail(match.home_team?.id, getTeamNameShow(match.home_team))"
              class="as-match__team as-match__team--home">
              <img :src="getImgUrlBySport('team', match.home_team?.id)" :alt="getTeamNameShow(match.home_team)"
                class="as-match__team--logo" />
              <div class="as-match__team--name as-match__team-home-name">
                {{ getTeamNameShow(match.home_team) }}
              </div>
            </a>
            <div class="as-scoreboard" @click="openPopup(match, competition)">
              <ScoreVs :match="match" :size="28" />
            </div>
            <a :href="getLinkTeamDetail(match.away_team?.id, getTeamNameShow(match.away_team))"
              class="as-match__team as-match__team--away">
              <img :src="getImgUrlBySport('team', match.away_team?.id)" :alt="getTeamNameShow(match.away_team)"
                class="as-match__team--logo" />
              <div class="as-match__team--name as-match__team-away-name">
                {{ getTeamNameShow(match.away_team) }}
              </div>
            </a>
          </div>
          <div class="as-match__video-highlight as-d-none as-d-lg-flex">
            <a v-if="match.highlight" :href="match.highlight?.url" rel="nofollow" title="Xem video highlight" class="as-match__play-highlight">
              Xem Highlight 
            </a>
          </div>
          <div class="as-match__ht as-d-none as-d-lg-flex">
            <div class="as-ht-btn">
              <span :class="{
                  'as-label-item-win':
                    match.home_scores[1] > match.away_scores[1],
                }">{{ match.home_scores[1] }}</span>
              <span>:</span>
              <span :class="{
                  'as-label-item-win':
                    match.home_scores[1] < match.away_scores[1],
                }">{{ match.away_scores[1] }}</span>
            </div>
          </div>
          <div class="as-match__corner as-d-none as-d-lg-flex">
            <div class="as-match__label-item">
              <span :class="{
                'as-label-item-win':
                    (match.half_time_statistics?.p1?.[2]?.[0] || 0) > (match.half_time_statistics?.p1?.[2]?.[1] || 0),
                }">
                {{ match.half_time_statistics?.p1?.[2]?.[0] || 0 }}
              </span>
              <span>-</span>
              <span :class="{
                'as-label-item-win':
                    (match.half_time_statistics?.p1?.[2]?.[0] || 0) < (match.half_time_statistics?.p1?.[2]?.[1] || 0),
                }">
                {{ match.half_time_statistics?.p1?.[2]?.[1] || 0 }}
              </span>
              <span class="as-separator">|</span>
              <span :class="{
                  'as-label-item-win':
                    match.home_scores[4] > match.away_scores[4],
                }">{{ match.home_scores[4] }}</span>
              <span>-</span>
              <span :class="{
                  'as-label-item-win':
                    match.home_scores[4] < match.away_scores[4],
                }">{{ match.away_scores[4] }}</span>
            </div>
          </div>
          <div class="as-match__yellow-goal as-d-none as-d-lg-flex">
            <div class="as-match__label-item">
              <span :class="{
                'as-label-item-win':
                    (match.half_time_statistics?.p1?.[3]?.[0] || 0) > (match.half_time_statistics?.p1?.[3]?.[1] || 0),
                }">
                {{ match.half_time_statistics?.p1?.[3]?.[0] || 0 }}
              </span>
              <span>-</span>
              <span :class="{
                'as-label-item-win':
                    (match.half_time_statistics?.p1?.[3]?.[0] || 0) < (match.half_time_statistics?.p1?.[3]?.[1] || 0),
                }">
                {{ match.half_time_statistics?.p1?.[3]?.[1] || 0 }}
              </span>
              <span class="as-separator">|</span>
              <span :class="{
                  'as-label-item-win':
                    match.home_scores[3] > match.away_scores[3],
                }">{{ match.home_scores[3] }}</span>
              <span>-</span>
              <span :class="{
                  'as-label-item-win':
                    match.home_scores[3] < match.away_scores[3],
                }">{{ match.away_scores[3] }}</span>
            </div>
          </div>
        </div>

        <div class="as-match__item--wrap as-p-0" v-if="
          match.home_scores[6] ||
            (match.agg_score && match.agg_score.length > 0)
          ">
          <div class="as-d-flex as-w-100 as-justify-content-between"></div>
          <div class="as-score-detail">
            {{ getScoreDetail(match) }}
          </div>
        </div>
      </div>
    </div>

    <Loading v-if="isLoadMoreInverse" class="as-mt-24" />

    <PopupComponent v-if="isShowPopup" :isShowPopup="isShowPopup" :match="matchPopup" :competition="competitionPopup"
      @toggle="closePopup()" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref, reactive, computed } from "vue";
import SvgSprite from "~src/components/matches/SvgSprite.vue";
import MatchEnum from "~src/enums/MatchEnum";
import PopupComponent from "~src/modules/result/components/PopupComponent.vue";
import Loading from "~src/components/Loading.vue";
import IconPlay from "~src/components/icons/IconPlay.vue";
import type { ICompetitions, IMatch, IFilterResult } from "~src/interfaces";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import {
  getRoundName,
  getTeamNameShow,
  getCompetitionNameShow,
} from "~src/helpers";
import IconCornerNew from "~src/components/icons/IconCornerNew.vue";
import IconYellowCard from "~src/components/icons/IconYellowCard.vue";
import ScoreVs from "~src/components/matches/ScoreVs.vue";
import { usecommonStore } from "~src/stores/CommonStore";
const commonStore = usecommonStore();
const emits = defineEmits(["loadInverse"]);

interface IProps {
  competitions?: Array<ICompetitions>;
  filter: IFilterResult;
  competitionType: number;
  isLoadMoreInverse: boolean;
  isLoadInverse: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  competitions: () => [],
  competitionType: 0,
});

const siteName = computed(() => commonStore.getSiteName);
const page = ref(1);
const isLoadMore = ref(false);
const competitionEnd = ref(0);
const scrollComponent = ref<HTMLElement | null>(null);
const leagues = ref<Array<ICompetitions>>([]);
const isShowPopup = ref(false);
const competitionPopup = ref<ICompetitions | null>(null);
const matchPopup = ref<IMatch | null>(null);

const openPopup = (match: IMatch, competition: ICompetitions) => {
  if (
    [...MatchEnum.LIST_STATUS_PLAYING, MatchEnum.STATUS_END].includes(
      match.status_id
    )
  ) {
    competitionPopup.value = competition;
    matchPopup.value = match;
    isShowPopup.value = true;

    // const body = document.body;
    // body.style.overflow = "hidden";
  }
};

const closePopup = () => {
  isShowPopup.value = false;
  // const body = document.body;
  // body.style.overflow = "auto";
};

onMounted(() => {
  loadMoreLeagues();
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

const getLeagues = () => {
  const limit = 50;
  const offset = page.value * limit;

  let count = 0;
  let datas: Array<ICompetitions> = [];
  props.competitions.forEach((competition: ICompetitions, index: any) => {
    if (
      (competitionEnd.value === 0 || competitionEnd.value < index) &&
      count < offset
    ) {
      datas.push(competition);
      if (competitionEnd.value < index) {
        competitionEnd.value = index;
      }
      count += competition.matchs.length;
    }
  });

  return datas;
};

const loadMoreLeagues = () => {
  if (
    isLoadMore.value &&
    props.competitions.length - 1 === competitionEnd.value
  ) {
    return;
  }
  isLoadMore.value = true;
  page.value = page.value + 1;
  let newleagues = getLeagues();
  leagues.value.push(...newleagues);
};

const handleScroll = (e: any) => {
  let element = scrollComponent.value;
  if (
    element &&
    element.getBoundingClientRect().bottom < window.window.innerHeight + 300
  ) {
    loadMoreLeagues();
  }
};

const getScoreDetail = (match: IMatch): string => {
  if (match.status_id !== MatchEnum.STATUS_END) {
    return "";
  }

  const homeTeamName = getTeamNameShow(match.home_team);
  const awayTeamName = getTeamNameShow(match.away_team);

  let scoreDetails = [];
  let advancingTeam: string | undefined = "";
  let winner = "";

  // Calculate match scores details
  const hasExtraTime = match.home_scores[5] > 0 || match.away_scores[5] > 0;
  const hasPenalties = match.home_scores[6] > 0 || match.away_scores[6] > 0;

  if (hasExtraTime || hasPenalties) {
    scoreDetails.push(
      `90 Phút [${match.home_scores[0]}-${match.away_scores[0]}]`
    );
  }
  if (hasExtraTime) {
    scoreDetails.push(
      `120 Phút [${match.home_scores[5]}-${match.away_scores[5]}]`
    );
  }
  if (hasPenalties) {
    scoreDetails.push(`Pen [${match.home_scores[6]}-${match.away_scores[6]}]`);
  }

  let aggregateHome: number = 0;
  let aggregateAway: number = 0;

  // Determine the winner
  if (match.leg && match.leg == "Second Leg") {
    if (match.agg_score && match.agg_score.length) {
      // check trường hợp trận chưa kết thúc lượt đi chưa cộng vs lượt về
      const isAggScoreTotal = parseInt(match.agg_score[0]) - match.home_scores[0] >= 0 && parseInt(match.agg_score[1]) - match.away_scores[0] >= 0;

      aggregateHome = isAggScoreTotal ? match.agg_score[0] : parseInt(match.agg_score[0]) + match.home_scores[0];
      aggregateAway = isAggScoreTotal ? match.agg_score[1] : parseInt(match.agg_score[0]) + match.away_scores[0];

      if (aggregateHome === aggregateAway) {
        winner = match.home_scores[6] > match.away_scores[6] ? homeTeamName : awayTeamName;
      } else {
        winner = aggregateHome > aggregateAway ? homeTeamName : awayTeamName;
      }
    } else if (
      match.home_scores[5] !== 0 ||
      match.away_scores[5] !== 0 ||
      match.home_scores[6] !== 0 ||
      match.away_scores[6] !== 0
    ) {
      if (
        match.home_scores[0] > match.away_scores[0] ||
        match.home_scores[5] > match.away_scores[5] ||
        match.home_scores[6] > match.away_scores[6]
      ) {
        winner = homeTeamName;
      } else if (
        match.home_scores[0] < match.away_scores[0] ||
        match.away_scores[5] > match.home_scores[5] ||
        match.away_scores[6] > match.home_scores[6]
      ) {
        winner = awayTeamName;
      }
    }
  } else if (
    match.home_scores[5] !== 0 ||
    match.away_scores[5] !== 0 ||
    match.home_scores[6] !== 0 ||
    match.away_scores[6] !== 0
  ) {
    if (
      match.home_scores[0] > match.away_scores[0] ||
      match.home_scores[5] > match.away_scores[5] ||
      match.home_scores[6] > match.away_scores[6]
    ) {
      winner = homeTeamName;
    } else if (
      match.home_scores[0] < match.away_scores[0] ||
      match.away_scores[5] > match.home_scores[5] ||
      match.away_scores[6] > match.home_scores[6]
    ) {
      winner = awayTeamName;
    }
  }

  // Handle leg information
  if (match.agg_score && match.leg && match.leg == "Second Leg") {
    if (match.agg_score.length) {
      const isOvertimeScore = match.home_scores[5] > 0 || match.away_scores[5] > 0;

      const legHomeScore = isOvertimeScore ? aggregateHome - match.home_scores[5] : aggregateHome - match.home_scores[0];
      const legAwayScore = isOvertimeScore ? aggregateAway - match.away_scores[5] : aggregateAway - match.away_scores[0];
      scoreDetails.push(
        `Lượt đi ${awayTeamName} ${legAwayScore}:${legHomeScore} ${homeTeamName}`
      );
    }

    advancingTeam = "";
    if (aggregateHome > aggregateAway) {
      advancingTeam = homeTeamName;
    } else if (aggregateHome < aggregateAway) {
      advancingTeam = awayTeamName;
    } else if (winner.length > 0) {
      advancingTeam = winner;
    }

    if (advancingTeam) {
      scoreDetails.push(`${advancingTeam} Tiến vào vòng trong`);
    } else if (winner) {
      scoreDetails.push(`${winner} thắng`);
    }
  } else if (winner) {
    scoreDetails.push(`${winner} thắng`);
  }

  return scoreDetails.join(", ");
};
</script>

<script lang="ts">
export default {};
</script>

<style scoped></style>
